import React, { useMemo } from 'react';
import TableCommonHook from '@op/components/TableCommonHook';
import { percentageFormat, reviewsFormat } from '@op/utils/value';
import { useIntl } from 'umi';
import { dealWithOthersName } from '@op/utils/languageValue';
import { channelInfo } from '@op/components/ChannelLabel';
import socialmedia from '@/pages/opinion/assets/svg/channel/socialmedia.svg';
import './index.scss';

const Table = (props: {
  filter: any;
  header: string;
  records: Array<any>;
  columnsConfig?: Array<any>;
  maxHeight?: number;
  minWidth?: number;
}) => {
  const {
    filter,
    header,
    records = [],
    columnsConfig,
    maxHeight = 250,
    minWidth = 700,
  } = props;
  const { formatMessage } = useIntl();

  const tableColumns = useMemo(() => {
    if (Array.isArray(columnsConfig) && columnsConfig.length) {
      return columnsConfig.map((item) => ({
        ...item,
        header: formatMessage({ id: item.header }),
      }));
    }
    const columns: any = [
      {
        key: 'name',
        header,
        align: 'left',
        render: (cvm: any) => {
          if (header === 'Channel') {
            const { img, name } = channelInfo(cvm.name, socialmedia);
            return (
              <div className="channel-language-div">
                <img src={img} />
                <span className="channel-language-span">
                  {formatMessage({ id: name })}
                </span>
              </div>
            );
          }
          return dealWithOthersName(cvm.name, header.toLocaleLowerCase());
        },
      },
      {
        key: 'count',
        header: 'Total Mentions',
        render: (cvm: any) => reviewsFormat(cvm.count),
        align: 'right',
        width: 130,
      },
      {
        key: 'positive_mentions',
        header: 'Positive%',
        render: (cvm: any) => percentageFormat(cvm.positive * 100),
        align: 'right',
        width: 130,
      },
      {
        key: 'neutral_mentions',
        header: 'Neutral%',
        render: (cvm: any) => percentageFormat(cvm.neutral * 100),
        align: 'right',
        width: 130,
      },
      {
        key: 'positive_mentions',
        header: 'Negative%',
        render: (cvm: any) => percentageFormat(cvm.negative * 100),
        align: 'right',
        width: 130,
      },
    ];

    return columns.map((item) => {
      const { header } = item;
      return {
        ...item,
        header: formatMessage({ id: header }),
      };
    });
  }, [columnsConfig, header, formatMessage]);

  return (
    <TableCommonHook
      recordKey={'key'}
      columns={tableColumns}
      total={records?.length}
      records={records}
      hasPageable={false}
      maxHeight={maxHeight}
      minWidth={minWidth}
    />
  );
};

export default Table;
